export const getApiDomain = (): string => {
  const isServerSide = typeof globalThis.window === 'undefined';
  return (isServerSide ? process.env.NEXT_PUBLIC_INTERNAL_API_DOMAIN : process.env.NEXT_PUBLIC_API_DOMAIN) as string;
};
